import styled from '@emotion/styled';

export const RuleSection = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const RuleInputGroup = styled.div`
  margin-bottom: 16px;
`;

export const RemoveButton = styled.div<{ theme?: any }>`
  color: ${({ theme }) => theme?.primary || '#ff6a00'};
  font-size: 12px;
  cursor: pointer;
  margin-top: -20px;
  margin-bottom: 10px;
  text-align: right;
`;

export const RoleSelect = styled.div<{ theme?: any }>`
  margin-top: 10px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${({ theme }) => theme?.stroke || '#d9d9d9'};

  &:last-child {
    border-bottom: none;
  }
`;
